module.exports = __webpack_public_path__ + "media/images/hero_images/brand-800-057ef67d581a7b7be8fa7143fd09b223.jpg";